import { BCDataGrid, findMessage } from '@bimser/components';
import { selectFile } from '@bimser/core';
import React from 'react';
import { FileToBase64 } from '../../../../../../helper';
import Styles from './assets/styles.scss';
import { ViewFile } from './ViewFile';
import DataGrid2 from '../..';

export const EditFileSelect: React.FC<any> = props => {
	const [value, setValue] = React.useState(props.data.value);

	const onValueChange = async (file: File) => {
		let base64;

		try {
			base64 = await FileToBase64(file);
		} catch {
			base64 = null;
		}

		props.data.setValue(base64);
		setValue(base64);
	};

	const onClick = () => {
		selectFile('image/*', e => {
			const [file] = e.target.files;

			if (file) {
				onValueChange(file);
			}
		});
	};

	if (value) {
		const dataGrid: DataGrid2 = props.data.column.retrieveDataGridInstance();

		return (
			<div
				className={`${Styles.imageCell} ${Styles.imageCellEdit}`}
				style={{ backgroundImage: `url(${value})` }}
			>
				<ViewFile
					dataGrid={dataGrid}
					column={dataGrid.__getBCColumn(props.data.column.name)}
					value={props.data.value}
				/>
				<i
					className="dx-icon-trash"
					onClick={() => onValueChange(null)}
				/>
			</div>
		);
	}

	return (
		<BCDataGrid.Components.Button
			width="100%"
			height={64}
			onClick={onClick}
		>
			<span>{findMessage.get('100637')}</span>
		</BCDataGrid.Components.Button>
	);
};
